<c-modal
  [class]="level | levelClass"
  [alignment]="c.alignment || 'center'"
  [backdrop]="c.backdrop"
  [id]="c.id"
  [visible]="visible"
  [size]="c | size"
  scrollable
>
  <c-modal-header>
    <h5 cModalTitle>{{ c.title }}</h5>
    <button (click)="closeMe()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    @if (iamVisible) {
      @switch (c.dialog) {
        @case (modalDialogs.ConfirmationDialogue) {
          <app-confirmation-dialogue
            #targetComponent
            [message]="c.model.in.message"
            [apiMethodCall]="c.model.in.apiMethodCall"
            [bizEntity]="c.model.in.bizEntity"
          ></app-confirmation-dialogue>
        }
        @case (modalDialogs.RenameDialogue) {
          <app-rename-dialogue
            #targetComponent
            [bizEntity]="c.model.in.bizEntity"
            [message]="c.model.in.message"
          ></app-rename-dialogue>
        }
                @case (modalDialogs.LibraryChooser) {
                  <app-template-explorer-modal-wrapper #targetComponent [modalCategory]="c.model.in?.modalCategory || null"></app-template-explorer-modal-wrapper>
                }

        @case (modalDialogs.GenericExplorer) {
          <lib-generic-explorer #targetComponent [entityTypeIds]="explorerEntityTypeIds" [appId]="explorerAppId" [isInModal]="true"></lib-generic-explorer>
        }
      }

    }
  </c-modal-body>

  <ng-container>
    @if (visible) {
      @if (c | hasFooter) {
        <c-modal-footer id="modalFooter">

          @for (btnConfig of c.footerButtons; track footerButtonsTrackBy($index, btnConfig)) {
          @if(c.selectedEntityDisplay && btnConfig.getData)
          {
            <div class="selected-entity-display">
              @for(item of c.selectedEntityDisplay; track $index)
              {
                @if(getData() && !isDisabled(btnConfig)){
                 {{selectedBizEntityText}} {{getData()[item.key]}}
                }
              }
            </div>
          }
            <div>
              <button
                (click)="onClick(btnConfig)"
                cButton
                [color]="btnConfig.color"
                [disabled]="isDisabled(btnConfig)"
              >
                {{ btnConfig.label }}
              </button>
            </div>
          }
        </c-modal-footer>
      }
    }
  </ng-container>
</c-modal>
